import React, { useState, useEffect } from 'react';
import images from '../../assets/images';
import PropTypes from 'prop-types';
//import { useRequest } from './../../hooks/useRequest';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
import { toast } from 'react-toastify';
import { useRequest } from '../../hooks/useRequest';
import moment from 'moment';
import { useFileReader } from '../../hooks/useFileReader';
import Select from 'react-select';
import {SelectStyle} from '../../constants/SelectStyle';

const CreatePostModal = ({ setOpenModal }) => {
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [modalData, setModalData] = useState({
    CategoryId: null, //done
    Description: '', //done
    Title: '', // done
    Medias: [],
    UnPublishDate: '',
    ForMyOrganization: true
  });
  const [imagesData, setImagesData, convert] = useFileReader();
  const token = cookies.get('token');

  const func = async () => {
    await request('post/getCategories', {
      method: 'GET'
    }).then((res) => {
      setCategoryList(res?.data?.result);
    });
  };
  useEffect(() => {
    func();
  }, []);

  const dataOnChange = (e) => {
    if (e.target.name === 'Medias') {
      setModalData({ ...modalData, [e.target.name]: e.target.files });
      convert(e.target.files);
    } else {
      setModalData({ ...modalData, [e.target.name]: e.target.value });
    }
  };
  const dataOnChangeSelect = (e) => {
    setModalData({ ...modalData, [e.name]: e.value });
  }
  const removeImg = (index) => {
    setImagesData((prev) => [...prev.filter((e, i) => i != index)]);
  };
  console.log('imagesData', imagesData);

  const createPost = (e) => {
    e.preventDefault();
    var myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);
    var formData = new FormData();
    formData.append('Model.CategoryId', modalData.CategoryId);
    formData.append('Model.Description', modalData.Description);
    formData.append('Model.Title', modalData.Title);
    formData.append('Model.UnPublishDate', modalData.UnPublishDate);
    formData.append('Model.ForMyOrganization', modalData.ForMyOrganization);

    for (let i = 0; i < imagesData.length; i++) {
      // setImageList(URL.createObjectURL(modalData?.Medias[i]))
      formData.append('Model.Medias', imagesData[i].raw);
    }
    //formData.append("Model.Medias", modalData.Medias);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formData,
      redirect: 'follow'
    };
    setLoading(true);
    fetch('http://havas-appronapi.nuevotest.com/api/post/addPost', requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.ok) {
          toast.success('Gönderiniz Yayınlandı', {
            autoClose: false
          }),
            setOpenModal(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        toast.error('POST Paylaşma İşlemi Hatalı', {
          autoClose: false
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="modal">
      {/* Modal content */}
      <div className="modal-content">
        <img
          onClick={() => setOpenModal(false)}
          className="modal-content--close"
          src={images.iconClose}
          alt="Close Icon"
          data-modal-close="data-modal-close"
        />
        <div className="edit-post-modal">
          <div className="edit-post-modal--header">Gönderi Paylaş</div>
          <form onSubmit={createPost} className="edit-post-modal--form">
            <div className="edit-post-modal--form--row">
              <div className="edit-post-modal--form--row--item">
                <label className="edit-post-modal--form--row--item--label" htmlFor="title">
                  Kategori
                </label>
                <Select styles={SelectStyle} onChange={dataOnChangeSelect} placeholder='Kategori Seçiniz' options={categoryList.map(c => ({label:c.title,value:c.id,name:'CategoryId'}))} />
              </div>
            </div>
            <div className="edit-post-modal--form--row">
              <div className="edit-post-modal--form--row--item">
                <label className="edit-post-modal--form--row--item--label" htmlFor="title">
                  Başlık
                </label>
                <textarea
                  name="Title"
                  onChange={dataOnChange}
                  className="edit-post-modal--form--row--item--textarea"
                  placeholder="Bir Başlık Yazın"
                  cols={50}
                  rows={3}
                />
              </div>
            </div>
            <div className="edit-post-modal--form--row">
              <div className="edit-post-modal--form--row--item">
                <div className="edit-post-modal--form--row--item--file-uploader">
                  <div className="edit-post-modal--form--row--item--file-uploader--images">
                    {imagesData.length > 0 &&
                      imagesData.map((image, i) => (
                        <div
                          key={i}
                          className="edit-post-modal--form--row--item--file-uploader--images--item">
                          <img
                            className="edit-post-modal--form--row--item--file-uploader--images--item--close"
                            src={images.iconCloseWhite}
                            onClick={() => removeImg(i)}
                            alt="Close Icon"
                          />
                          {image.raw?.type?.includes('video') ? (
                            <video width="60">
                              <source src={image.url} type={image.raw?.type} />
                              Your browser does not support HTML5 video.
                            </video>
                          ) : (
                            <img
                              className="edit-post-modal--form--row--item--file-uploader--images--item--img"
                              src={image.url}
                            />
                          )}
                        </div>
                      ))}
                  </div>
                  <label
                    className="edit-post-modal--form--row--item--file-uploader--label"
                    htmlFor="file-uploader">
                    <img
                      className="edit-post-modal--form--row--item--file-uploader--label--img"
                      src={images.iconUpload}
                      alt="Upload Image"
                    />
                    <span className="edit-post-modal--form--row--item--file-uploader--label--text">
                      Fotoğraf Seçin
                    </span>
                  </label>
                  <input
                    onChange={dataOnChange}
                    name="Medias"
                    type="file"
                    accept="image/*"
                    multiple
                    id="file-uploader"
                    className="edit-post-modal--form--row--item--file-uploader--input"
                  />
                </div>
              </div>
            </div>
            <div className="edit-post-modal--form--row">
              <div className="edit-post-modal--form--row--item">
                <label className="edit-post-modal--form--row--item--label" htmlFor="title">
                  Açıklama
                </label>
                <textarea
                  name="Description"
                  onChange={dataOnChange}
                  className="edit-post-modal--form--row--item--textarea"
                  placeholder="Gönderi Detay Metni Girin"
                  rows={5}
                />
              </div>
            </div>
            <div className="edit-post-modal--form--row">
              <div className="edit-post-modal--form--row--item">
                <label className="edit-post-modal--form--row--item--label" htmlFor="title">
                  Bildirim Alacaklar
                </label>
                <Select styles={SelectStyle} onChange={dataOnChangeSelect} isSearchable={false} defaultValue={{value:true,label:'İstasyonum'}} options={[{value:true,label:'İstasyonum',name:'ForMyOrganization'},{value:false,label:'Tüm Şirket',name:'ForMyOrganization'}]} />
              </div>
            </div>
            <div className="edit-post-modal--form--row--item">
              <label className="edit-post-modal--form--row--item--label" htmlFor="unPublishDate">
                Yayından Kaldırılacağı Tarih
              </label>
              <input
                min={moment(new Date()).format().split('T')[0]}
                id="unPublishDate"
                type="date"
                onChange={dataOnChange}
                //value={post.unPublishDate?.split('T')[0]}
                placeholder="Yayından Kalkacağı Tarih (Opsiyonel)"
                className="edit-post-modal--form--row--item--date-picker"
                name="UnPublishDate"
              />
            </div>
            {/* <div className="edit-post-modal--form--row">
              <div className="edit-post-modal--form--row--item">
                <input
                  type="text"
                  //onfocus="(this.type='date')"
                  placeholder="Yayından Kalkacağı Tarih (Opsiyonel)"
                  className="edit-post-modal--form--row--item--date-picker"
                />
              </div>
            </div> */}
            <div className="edit-post-modal--form--row">
              <div className="edit-post-modal--form--row--item">
                <div className="edit-post-modal--form--row--item--button">
                  <button disabled={loading} className="default-green-button">
                    İçeriği Yayınla
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
CreatePostModal.propTypes = {
  setOpenModal: PropTypes.func
};

export default CreatePostModal;
